import React, { useState, useEffect } from "react";
import "../CSS/ElCarancho.css";

const PRODUCTOS = [
  { id: "hamburguesa", nombre: "Hamburguesa completa", precio: 6500 },
  { id: "asado", nombre: "Asado de tira (1 kg)", precio: 9500 },
  { id: "vacío", nombre: "Vacío (1 kg)", precio: 10500 },
  { id: "lomo", nombre: "Lomo (1 kg)", precio: 14500 },
  { id: "molida", nombre: "Carne picada (1 kg)", precio: 7500 },
  { id: "combo-familiar", nombre: "Combo familiar parrillero", precio: 28000 },
];

const PREMIOS = [
  { puntos: 400, descripcion: "Hamburguesa clásica gratis" },
  { puntos: 900, descripcion: "½ kg de asado de tira" },
  { puntos: 1600, descripcion: "1 kg de vacío o molida premium" },
  { puntos: 2500, descripcion: "Caja parrillera El Carancho" },
];

// 1 punto por cada $100 gastados
const calcularPuntos = (monto) => Math.floor(monto / 100);

export default function ElCarancho() {
  const [email, setEmail] = useState("");
  const [nombre, setNombre] = useState("");
  const [usuarioActual, setUsuarioActual] = useState(null);

  const [productoId, setProductoId] = useState(PRODUCTOS[0].id);
  const [cantidad, setCantidad] = useState(1);

  // Cargar usuario desde localStorage si ya existe
  useEffect(() => {
    const guardado = localStorage.getItem("elcarancho_usuario");
    if (guardado) {
      setUsuarioActual(JSON.parse(guardado));
    }
  }, []);

  // Guardar usuario si cambia
  useEffect(() => {
    if (usuarioActual) {
      localStorage.setItem("elcarancho_usuario", JSON.stringify(usuarioActual));
    }
  }, [usuarioActual]);

  const manejarLogin = (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    // Si ya existe, lo cargamos
    const guardado = localStorage.getItem("elcarancho_usuario");
    if (guardado) {
      const u = JSON.parse(guardado);
      if (u.email === email.trim()) {
        setUsuarioActual(u);
        return;
      }
    }

    // Nuevo usuario
    const nuevo = {
      nombre: nombre || "Cliente El Carancho",
      email: email.trim(),
      puntos: 0,
      compras: [],
    };
    setUsuarioActual(nuevo);
  };

  const manejarCompra = (e) => {
    e.preventDefault();
    if (!usuarioActual) return;

    const producto = PRODUCTOS.find((p) => p.id === productoId);
    const cant = Math.max(1, Number(cantidad) || 1);
    const subtotal = producto.precio * cant;
    const puntosGanados = calcularPuntos(subtotal);

    const nuevaCompra = {
      id: Date.now(),
      producto: producto.nombre,
      cantidad: cant,
      subtotal,
      puntosGanados,
      fecha: new Date().toLocaleDateString("es-AR"),
    };

    setUsuarioActual((prev) => ({
      ...prev,
      puntos: prev.puntos + puntosGanados,
      compras: [nuevaCompra, ...prev.compras],
    }));

    setCantidad(1);
    setProductoId(PRODUCTOS[0].id);
  };

  const cerrarSesion = () => {
    setUsuarioActual(null);
    localStorage.removeItem("elcarancho_usuario");
    setEmail("");
    setNombre("");
  };

  const siguientePremio =
    usuarioActual &&
    PREMIOS.find((premio) => premio.puntos > usuarioActual.puntos);

  const progreso =
    usuarioActual && siguientePremio
      ? Math.min(
          100,
          Math.round((usuarioActual.puntos / siguientePremio.puntos) * 100)
        )
      : 100;

  return (
    <div className="EC-root">
      <header className="EC-header">
        <div className="EC-brand">
          <span className="EC-logo">🦅</span>
          <div>
            <h1>El Carancho</h1>
            <p>Sistema de Puntos · Club de Carnes</p>
          </div>
        </div>

        {usuarioActual && (
          <button className="EC-logout" onClick={cerrarSesion}>
            Cerrar sesión
          </button>
        )}
      </header>

      {!usuarioActual ? (
        <section className="EC-card EC-auth">
          <h2>Ingresá a tu cuenta</h2>
          <p className="EC-muted">
            Creá tu cuenta del Club El Carancho y empezá a sumar puntos en cada
            compra.
          </p>
          <form onSubmit={manejarLogin} className="EC-form">
            <div className="EC-field">
              <label>Nombre</label>
              <input
                type="text"
                placeholder="Ej. Martina, Nicolás..."
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>
            <div className="EC-field">
              <label>Email</label>
              <input
                type="email"
                placeholder="tu@mail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="EC-primary">
              Entrar / Crear cuenta
            </button>
          </form>
        </section>
      ) : (
        <>
          <section className="EC-grid">
            <div className="EC-card EC-points">
              <h2>Hola, {usuarioActual.nombre}</h2>
              <p className="EC-muted">Resumen de tus puntos</p>

              <div className="EC-points-main">
                <span className="EC-points-label">Puntos acumulados</span>
                <span className="EC-points-value">
                  {usuarioActual.puntos.toLocaleString("es-AR")}
                </span>
              </div>

              {siguientePremio ? (
                <>
                  <div className="EC-next-reward">
                    <p>
                      Te faltan{" "}
                      <strong>
                        {siguientePremio.puntos - usuarioActual.puntos}
                      </strong>{" "}
                      puntos para:
                    </p>
                    <p className="EC-reward-name">
                      🎁 {siguientePremio.descripcion}
                    </p>
                  </div>
                  <div className="EC-progress">
                    <div
                      className="EC-progress-bar"
                      style={{ width: `${progreso}%` }}
                    />
                  </div>
                  <p className="EC-progress-text">{progreso}% hacia tu premio</p>
                </>
              ) : (
                <p className="EC-reward-name">
                  🎉 Ya alcanzaste todos los premios del programa actual.
                </p>
              )}
            </div>

            <div className="EC-card EC-purchase">
              <h2>Cargar una compra</h2>
              <p className="EC-muted">
                Elegí el producto y cantidad. El sistema calcula el total y los
                puntos.
              </p>

              <form onSubmit={manejarCompra} className="EC-form">
                <div className="EC-field">
                  <label>Producto</label>
                  <select
                    value={productoId}
                    onChange={(e) => setProductoId(e.target.value)}
                  >
                    {PRODUCTOS.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.nombre} · ${p.precio.toLocaleString("es-AR")}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="EC-field">
                  <label>Cantidad</label>
                  <input
                    type="number"
                    min="1"
                    value={cantidad}
                    onChange={(e) => setCantidad(e.target.value)}
                  />
                </div>

                <div className="EC-summary">
                  {(() => {
                    const prod = PRODUCTOS.find((p) => p.id === productoId);
                    const cant = Math.max(1, Number(cantidad) || 1);
                    const subtotal = prod.precio * cant;
                    const pts = calcularPuntos(subtotal);
                    return (
                      <>
                        <p>
                          Total estimado:{" "}
                          <strong>
                            ${subtotal.toLocaleString("es-AR")}
                          </strong>
                        </p>
                        <p>
                          Puntos que sumás: <strong>{pts}</strong>
                        </p>
                      </>
                    );
                  })()}
                </div>

                <button type="submit" className="EC-primary">
                  Cargar compra y sumar puntos
                </button>
              </form>
            </div>
          </section>

          <section className="EC-card EC-rewards">
            <h2>Premios del Club El Carancho</h2>
            <p className="EC-muted">
              Cada $100 gastados suman 1 punto. Mientras más parrillás, más
              ganás.
            </p>
            <div className="EC-rewards-list">
              {PREMIOS.map((premio) => (
                <div key={premio.puntos} className="EC-reward-item">
                  <div>
                    <p className="EC-reward-points">
                      {premio.puntos.toLocaleString("es-AR")} pts
                    </p>
                    <p className="EC-reward-desc">{premio.descripcion}</p>
                  </div>
                  {usuarioActual.puntos >= premio.puntos ? (
                    <span className="EC-chip EC-chip-earned">Disponible</span>
                  ) : (
                    <span className="EC-chip">
                      Faltan{" "}
                      {premio.puntos - usuarioActual.puntos > 0
                        ? (premio.puntos - usuarioActual.puntos).toLocaleString(
                            "es-AR"
                          )
                        : 0}{" "}
                      pts
                    </span>
                  )}
                </div>
              ))}
            </div>
          </section>

          {usuarioActual.compras.length > 0 && (
            <section className="EC-card EC-history">
              <h2>Historial de compras</h2>
              <p className="EC-muted">
                Vemos las últimas compras registradas en tu cuenta.
              </p>
              <div className="EC-table-wrapper">
                <table className="EC-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Producto</th>
                      <th>Cant.</th>
                      <th>Subtotal</th>
                      <th>Puntos</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuarioActual.compras.map((c) => (
                      <tr key={c.id}>
                        <td>{c.fecha}</td>
                        <td>{c.producto}</td>
                        <td>{c.cantidad}</td>
                        <td>${c.subtotal.toLocaleString("es-AR")}</td>
                        <td>{c.puntosGanados}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
}
